import React from 'react';

import classes from 'components/Dashboards/Reporting/WidgetNarrativeWrapper/WidgetsNarrative.module.scss';

interface Props {
    editNarrative?: React.ReactNode;
}

// TODO: Check if this component should be in use
export const Narrative = ({ editNarrative }: Props) => {
    if (!editNarrative) return null;
    return <div className={classes.WidgetsNarrative}>{editNarrative}</div>;
};
